import { appUrl } from '@astro/config'

const FEATURES = [
  { icon: 'fa-award', label: 'Certified Courses' },
  { icon: 'fa-video', label: 'Live + Recorded Sessions' },
  { icon: 'fa-shield-halved', label: 'Expert Mentorship' },
]

export default function AcademyCtaSection() {
  return (
    <section className="relative overflow-hidden py-20 md:py-24 bg-astroDeep text-white border-t border-white/5">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-24 top-0 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.1)_0%,transparent_70%)] blur-3xl"></div>
        <div className="absolute -left-24 bottom-0 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(122,31,43,0.22)_0%,transparent_70%)] blur-3xl"></div>
      </div>

      <div className="container relative z-10 mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-2xl text-center space-y-5">
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Vedic Academy</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-[#FBF3E4]">
            Learn the <span className="text-gradient-gold font-bold block">Sacred Science</span>
          </h2>
          <p className="text-xs md:text-sm leading-relaxed text-white/55">
            Go beyond wearing remedies — understand them. Master Vedic astrology, numerology and palmistry through certified courses and live masterclasses, guided personally by Raju Maharaj Ji.
          </p>

          <div className="flex flex-wrap justify-center gap-3 pt-2">
            {FEATURES.map((f) => (
              <div key={f.label} className="flex items-center gap-2.5 px-5 py-2 rounded-full border border-white/10 bg-white/5 text-[10px] font-medium uppercase tracking-widest text-white/60">
                <i className={`fa-solid ${f.icon} text-secondary`}></i> {f.label}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <a
              href={appUrl('education')}
              className="group inline-flex items-center justify-center whitespace-nowrap shine-btn bg-linear-to-r from-goldAccent to-goldPrimary text-astroDark font-bold px-10 py-4 rounded-full text-xs uppercase tracking-widest shadow-lg shadow-goldPrimary/20 transition-transform hover:-translate-y-0.5"
            >
              Explore Academy <i className="fa-solid fa-arrow-right ml-2 transition-transform group-hover:translate-x-1"></i>
            </a>
            <a
              href={appUrl('education', 'classes')}
              className="inline-flex items-center justify-center whitespace-nowrap px-10 py-4 rounded-full border border-[#E6C878]/40 text-[#FBF3E4] font-bold text-xs uppercase tracking-widest transition-all hover:border-[#E6C878] hover:text-goldPrimary"
            >
              Book a Free Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
